import Swiper, { Pagination, Navigation } from 'swiper';

export namespace Global {

  let calcScrollbarWidth = () => {
    // Creating invisible container
    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll'; // forcing scrollbar to appear
    document.body.appendChild(outer);

    // Creating inner element and placing it in the container
    const inner = document.createElement('div');
    outer.appendChild(inner);

    // Calculating difference between container's full width and the child width
    const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);

    document.documentElement.style.setProperty(
          '--scrollbar-width',
          scrollbarWidth + 'px'
      );

    // Removing temporary elements from the DOM
    outer.parentNode.removeChild(outer);
  };

  let initSwiper = () => {
    // init Swiper:
    const swiper = new Swiper('.swiper', {
        // configure Swiper to use modules
        modules: [Navigation, Pagination],
        watchOverflow: true,
        centeredSlides: true,
        watchSlidesProgress: true,
        speed: 1000,
        spaceBetween: 30,
        initialSlide: 1,
        slidesPerView: 'auto',
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true
        },
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
    });

    // different configurations for our single slider
    let singleSliders = document.querySelectorAll('.swiper-single');

    if (singleSliders){
      singleSliders.forEach(function(slider, index) {
        slider.classList.add('swiper-single-' + index);
        const swiperSingle = new Swiper('.swiper-single-' + index, {
          // configure Swiper to use modules
          modules: [Navigation, Pagination],
          watchSlidesProgress: true,
          initialSlide: 0,
          speed: 1000,
          slidesPerView: 1,
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
          },
          navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
          },
        });
      })
    }
  };

  let Accordion = () => {
    let accordionItems = document.querySelectorAll('.js-acc-trigger');
    if (accordionItems){
      accordionItems.forEach(function(accordionItem){
        let parent = accordionItem.closest('.js-acc-item')
        accordionItem.addEventListener('click', e => {
            e.preventDefault();
            parent.classList.toggle('state-open');
        })
      });
    }
  }

	let setupMainNavigation = () => {
		let navTrigger = document.querySelector('.js-mobile-trigger');
		let body = document.body;

        if (navTrigger != null){
            navTrigger.addEventListener('click', () => {
                let parentEl = navTrigger.parentElement;

                if(parentEl.classList.contains('state-nav-open')) {
                    parentEl.classList.remove('state-nav-open');
                    body.classList.remove('state-fixed');
                } else {
                    parentEl.classList.add('state-nav-open');
                    body.classList.add('state-fixed');
                }
            });
        }
	}

  /**
   * Container Initialization
   */
  export const init = () => {
    setupMainNavigation();
    calcScrollbarWidth();
    initSwiper();
    Accordion();
  };
}

document.addEventListener("DOMContentLoaded", () => {
    Global.init();
});
